module.exports = __webpack_public_path__ + "img/logo-mini.544d98fb.png";